import { IonCard, IonCardContent, IonIcon, IonLabel } from '@ionic/react';
import React, { PropsWithChildren } from 'react';

import DangerIcon from '@shared/assets/icons/error_outline.svg';
import InfoIcon from '@shared/assets/icons/info.svg';
import WarningIcon from '@shared/assets/icons/warning.svg';

import styles from './Alert.module.css';

type AlertProps = {
  type: 'info' | 'warning' | 'danger';
  title?: string;
  className?: string;
  onClick?: () => void;
};

const iconMap: Record<AlertProps['type'], string> = {
  info: InfoIcon,
  warning: WarningIcon,
  danger: DangerIcon,
};

const Alert = ({ type, title, className, onClick, children }: PropsWithChildren<AlertProps>) => {
  const icon = iconMap[type];

  return (
    <IonCard className={`${styles.alertCard} ${styles[type]} ${className}`} onClick={onClick}>
      <IonCardContent className={`stack stack-horizontal ${styles.contentAlert}`}>
        <IonIcon icon={icon} className={styles.iconAlert} />

        <div className="stack stack-no-space">
          <IonLabel className={styles.title}>{title}</IonLabel>
          {children}
        </div>
      </IonCardContent>
    </IonCard>
  );
};

export type { AlertProps };

export default Alert;
